'use client';

import { fallbackLng } from '@/i18n-config';
import { Dictionary } from '@/lib/get-dictionary';
import { getProductInfo } from '@/utils/testConfig';
import { Action } from '@soluto-private/mx-asurion-ui-react';
import { useParams, usePathname, useSearchParams } from 'next/navigation';

export function SwitchLanguageActionButton({
  dictionary,
}: {
  dictionary: Dictionary;
}) {
  const params = useParams();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const productInfo = getProductInfo({
    partner: (params.partner as string) ?? '',
    product: (params.product as string) ?? '',
  });
  const urlParams = new URLSearchParams(searchParams);
  const productPath = pathname.replace(`/${params.lang}`, '');
  const langUrlPath =
    dictionary?.languages.action.langParam !== fallbackLng
      ? `/${dictionary?.languages.action.langParam}`
      : '';
  return productInfo?.product?.allowedLocales &&
    dictionary &&
    productInfo.product.allowedLocales.length > 1 ? (
    <Action variant="flat" href={`${langUrlPath}${productPath}/?${urlParams}`}>
      {dictionary.languages.action.buttonText}
    </Action>
  ) : null;
}
